import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref } from "vue"

const _hoisted_1 = { class: "content2" }
const _hoisted_2 = { class: "order-message" }
const _hoisted_3 = { class: "content_list_item_top" }
const _hoisted_4 = { class: "content_list_item_top_left" }
const _hoisted_5 = { class: "content_list_item_top_right" }
const _hoisted_6 = {
  key: 0,
  class: "created"
}
const _hoisted_7 = {
  key: 1,
  class: "warning"
}
const _hoisted_8 = {
  key: 2,
  class: "green"
}
const _hoisted_9 = {
  key: 3,
  class: "info"
}
const _hoisted_10 = { class: "content_list_item_content" }
const _hoisted_11 = {
  style: {"margin-top":"0"},
  class: "content_list_item_content_item"
}
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "单据类型：", -1)
const _hoisted_13 = { class: "content_list_item_content_item_nr" }
const _hoisted_14 = { class: "content_list_item_content_item" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转出组织：", -1)
const _hoisted_16 = { class: "content_list_item_content_item_nr" }
const _hoisted_17 = { class: "content_list_item_content_item" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转入组织：", -1)
const _hoisted_19 = { class: "content_list_item_content_item_nr" }
const _hoisted_20 = { class: "content_list_item_content_item" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转出仓库：", -1)
const _hoisted_22 = { class: "content_list_item_content_item_nr" }
const _hoisted_23 = { class: "content_list_item_content_item" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转出仓管员：", -1)
const _hoisted_25 = { class: "content_list_item_content_item_nr" }
const _hoisted_26 = { class: "content_list_item_content_item" }
const _hoisted_27 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转入仓库：", -1)
const _hoisted_28 = { class: "content_list_item_content_item_nr" }
const _hoisted_29 = { class: "content_list_item_content_item" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "转入仓管员：", -1)
const _hoisted_31 = { class: "content_list_item_content_item_nr" }
const _hoisted_32 = { class: "content_list_item_content_item" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划转出日期：", -1)
const _hoisted_34 = { class: "content_list_item_content_item_nr" }
const _hoisted_35 = { class: "content_list_item_content_item" }
const _hoisted_36 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划转入日期：", -1)
const _hoisted_37 = { class: "content_list_item_content_item_nr" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "material-title" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "title" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "title-prefix" }),
    /*#__PURE__*/_createElementVNode("span", null, "转库物料")
  ])
], -1)
const _hoisted_39 = { class: "material-content" }
const _hoisted_40 = { class: "item-title-style" }
const _hoisted_41 = { style: {"font-weight":"500"} }
const _hoisted_42 = { class: "item-content-style" }
const _hoisted_43 = { class: "content_list_item_content_item" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "批次号：", -1)
const _hoisted_45 = { class: "content_list_item_content_item_nr" }
const _hoisted_46 = { class: "content_list_item_content_item" }
const _hoisted_47 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "工序：", -1)
const _hoisted_48 = { class: "content_list_item_content_item_nr" }
const _hoisted_49 = { class: "content_list_item_content_item" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "质量：", -1)
const _hoisted_51 = { class: "content_list_item_content_item_nr" }
const _hoisted_52 = {
  key: 0,
  class: "green"
}
const _hoisted_53 = {
  key: 1,
  class: "yellow"
}
const _hoisted_54 = {
  key: 2,
  class: "red"
}
const _hoisted_55 = { key: 3 }
const _hoisted_56 = { class: "content_list_item_content_item" }
const _hoisted_57 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "计划转库数量：", -1)
const _hoisted_58 = { class: "content_list_item_content_item_nr" }
const _hoisted_59 = { class: "content_list_item_content_item" }
const _hoisted_60 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "实际转出数量：", -1)
const _hoisted_61 = { class: "content_list_item_content_item_nr" }
const _hoisted_62 = { class: "content_list_item_content_item" }
const _hoisted_63 = /*#__PURE__*/_createElementVNode("div", { class: "content_list_item_content_item_label" }, "实际转入数量：", -1)
const _hoisted_64 = { class: "content_list_item_content_item_nr" }
const _hoisted_65 = {
  key: 0,
  style: {"background":"#F7F7F7","height":"94px"}
}
const _hoisted_66 = {
  key: 1,
  class: "bottom-button"
}

import { onMounted, ref, reactive } from 'vue'
  import { useRoute, useRouter } from 'vue-router'
  import { useStore } from "vuex"
  import { Toast } from 'vant'
  import { wTransferExtDetail } from '@/apis/materialStorage'

  interface TransferDetailModel {
    code: string;
    status: number;
    outDepartName: string;
    inDepartName: string;
    outWarehouseName: string;
    inWarehouseName: string;
    outPlandate: string;
    inPlandate: string;
    wtransferDetailList: Array<{
      materialName: string,
      materialCode: string,
      batch: string,
      outPlannum: number,
      inActnum: number,
      outActnum: number,
      unitName: string,
    }>;
  }
  
export default /*#__PURE__*/_defineComponent({
  setup(__props) {

  const route = useRoute()
  const router = useRouter()
  const store = useStore()
  const data: any = ref<TransferDetailModel>(
{
      code: "",
      status: 0,
      outDepartName: "",
      inDepartName: "",
      outWarehouseName: "",
      inWarehouseName: "",
      outPlandate: "",
      inPlandate: "",
      wtransferDetailList: []
    }
  )
  let show = ref<boolean>(false)

  // 跳转出库入库
  const submit = (): void => {
    if (data.value.status === 0) {  // 出库
      router.push({ name: 'issueOperation', query: { id: route.query.id, type: 7 } })
    } else if (data.value.status === 1) {  // 入库
      if (data.value.type === 3) {  // 备料确认
        router.push({ name: 'orderStock', query: { id: route.query.id, status: data.value.status, next: 1 } })
        return
      }
      router.push({ name: 'warehousing', query: { id: route.query.id, type: 7 } })
    }
  }

  const orderType = reactive<Array<{name: string; id: Number;}>>([
      { name: '车间领料', id: 1 },
      { name: '计划领料', id: 2 },
      { name: '机台备料', id: 3 },
      { name: '完工入库', id: 4 },
      { name: '车间转库', id: 5 },
      { name: '外协领料转库', id: 6 },
      { name: '外协完工转库', id: 7 },
      { name: '成品入库', id: 8 },
      { name: '成品转库', id: 9 },
      { name: '让步放行入库', id: 10 },
      { name: '让步放行转库', id: 11 },
      { name: '客返返修领料', id: 12 },
      { name: '客返返修入库', id: 13 },
      { name: '跨组织转库', id: 14 },
      { name: '工序报废', id: 15 },
      { name: '客退返修领料', id: 16 },
      { name: '客退返修入库', id: 17 },
  ]);


  onMounted(() => {
    wTransferExtDetail(route.query.id)
      .then(res => {
        data.value = res.data
        if (res.data.inUserId == store.state.userInfo.id) {
          show.value = true
        }
      })
  })

  const tyepToStr = (type: number): string => {
    //  <!-- 1、车间领料；2、车间备料；3、其他；4、完工入库 -->
    for (const item of orderType) {
      if (item.id == type) {
        return item.name
      }
    }
    return '-'
  }

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("span", null, _toDisplayString(data.value.code), 1)
        ]),
        _createElementVNode("div", _hoisted_5, [
          (data.value.status === 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_6, "待出库"))
            : (data.value.status === 1)
              ? (_openBlock(), _createElementBlock("span", _hoisted_7, "已出库"))
              : (data.value.status == 2)
                ? (_openBlock(), _createElementBlock("span", _hoisted_8, "已入库"))
                : (data.value.status === 3)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_9, "已取消"))
                  : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("div", _hoisted_10, [
        _createElementVNode("div", _hoisted_11, [
          _hoisted_12,
          _createElementVNode("div", _hoisted_13, _toDisplayString(tyepToStr(data.value.type)), 1)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _hoisted_15,
          _createElementVNode("div", _hoisted_16, _toDisplayString(data.value.outDepartName), 1)
        ]),
        _createElementVNode("div", _hoisted_17, [
          _hoisted_18,
          _createElementVNode("div", _hoisted_19, _toDisplayString(data.value.inDepartName), 1)
        ]),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, _toDisplayString(data.value.outWarehouseName), 1)
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _createElementVNode("div", _hoisted_25, _toDisplayString(data.value.outUserName), 1)
        ]),
        _createElementVNode("div", _hoisted_26, [
          _hoisted_27,
          _createElementVNode("div", _hoisted_28, _toDisplayString(data.value.inWarehouseName), 1)
        ]),
        _createElementVNode("div", _hoisted_29, [
          _hoisted_30,
          _createElementVNode("div", _hoisted_31, _toDisplayString(data.value.inUserName), 1)
        ]),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, _toDisplayString(data.value.outPlandate), 1)
        ]),
        _createElementVNode("div", _hoisted_35, [
          _hoisted_36,
          _createElementVNode("div", _hoisted_37, _toDisplayString(data.value.inPlandate), 1)
        ])
      ]),
      _hoisted_38,
      _createElementVNode("div", _hoisted_39, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(data.value.wtransferDetailList, (item, index) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "item-style",
            key: index
          }, [
            _createElementVNode("div", _hoisted_40, [
              _createElementVNode("span", _hoisted_41, _toDisplayString(item.materialName + ' | ' + item.materialCode), 1)
            ]),
            _createElementVNode("div", _hoisted_42, [
              _createElementVNode("div", _hoisted_43, [
                _hoisted_44,
                _createElementVNode("div", _hoisted_45, _toDisplayString(item.batch), 1)
              ]),
              _createElementVNode("div", _hoisted_46, [
                _hoisted_47,
                _createElementVNode("div", _hoisted_48, _toDisplayString(item.procedureName || '-'), 1)
              ]),
              _createElementVNode("div", _hoisted_49, [
                _hoisted_50,
                _createElementVNode("div", _hoisted_51, [
                  (item.qualityType==0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_52, "合格"))
                    : (item.qualityType==1)
                      ? (_openBlock(), _createElementBlock("span", _hoisted_53, "不良"))
                      : (item.qualityType==2)
                        ? (_openBlock(), _createElementBlock("span", _hoisted_54, "报废"))
                        : (_openBlock(), _createElementBlock("span", _hoisted_55, "-"))
                ])
              ]),
              _createElementVNode("div", _hoisted_56, [
                _hoisted_57,
                _createElementVNode("div", _hoisted_58, _toDisplayString(item.outPlannum + item.unitName), 1)
              ]),
              _createElementVNode("div", _hoisted_59, [
                _hoisted_60,
                _createElementVNode("div", _hoisted_61, _toDisplayString(item.outActnum + item.unitName), 1)
              ]),
              _createElementVNode("div", _hoisted_62, [
                _hoisted_63,
                _createElementVNode("div", _hoisted_64, _toDisplayString(item.inActnum + item.unitName), 1)
              ])
            ])
          ]))
        }), 128))
      ])
    ]),
    ((data.value.status === 0 || data.value.status === 1) && _unref(show))
      ? (_openBlock(), _createElementBlock("div", _hoisted_65))
      : _createCommentVNode("", true),
    ((data.value.status === 0 || data.value.status === 1) && _unref(show))
      ? (_openBlock(), _createElementBlock("div", _hoisted_66, [
          _createElementVNode("button", {
            class: "button",
            onClick: submit
          }, _toDisplayString(data.value.status === 0 ? '去出库' : '去入库'), 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})